import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"

export type MediaQuality = 'low' | 'normal' | 'medium' | 'high' | 'custom'

export class PhotoOptionsVM extends CommonOptionVM {
  multi_photo?: boolean
  allow_camera?: boolean
  photo_library?: boolean
  allow_gps_tagging?: boolean
  default_value?: string | number | null
  quality?: MediaQuality
  required?: boolean

  constructor(data: Partial<PhotoOptionsVM> = {}) {
    super(data)
    this.multi_photo = data?.multi_photo ?? undefined
    this.allow_camera = data?.allow_camera ?? undefined
    this.photo_library = data?.photo_library ?? undefined
    this.allow_gps_tagging = data?.allow_gps_tagging ?? undefined
    this.default_value = data?.default_value ?? undefined
    this.quality = data?.quality ?? undefined
    this.required = data?.required ?? undefined
  }

  validateData() {
    const errors: any[] = []
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default PhotoOptionsVM